import { api } from "@/utils/apiConfig.js";
import axios from "axios";
import store from "@/store";


// 日期格式化
export function parseTime(date, fmt) {
    let ret;
    const opt = {
        "Y+": date.getFullYear().toString(),        // 年
        "m+": (date.getMonth() + 1).toString(),     // 月
        "d+": date.getDate().toString(),            // 日
        "H+": date.getHours().toString(),           // 时
        "M+": date.getMinutes().toString(),         // 分
        "S+": date.getSeconds().toString(),         // 秒
        "s+": date.getMilliseconds().toString()     // 毫秒
        // 有其他格式化字符需求可以继续添加，必须转化成字符串
    };
    for (let k in opt) {
        ret = new RegExp("(" + k + ")").exec(fmt);
        if (ret) {
            fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
        };
    };
    return fmt;
}

// 将字符串转为时间戳
export function getTimestampFromString(str) {
    var reg = /^(\d+)-(\d+)-(\d+) (\d+):(\d+):(\d+)/;
    var s = str.match(reg);
    var result = "";
    if (s) {
        result = new Date(s[1], s[2] - 1, s[3], s[4], s[5], s[6]);
    }
    return result.getTime() / 1000;
}

export function getWeekDay(date) {
    let dayTxt = "";
    switch (date.getDay()) {
        case 1:
            dayTxt = "周一";
            break;
        case 2:
            dayTxt = "周二";
            break;
        case 3:
            dayTxt = "周三";
            break;
        case 4:
            dayTxt = "周四";
            break;
        case 5:
            dayTxt = "周五";
            break;
        case 6:
            dayTxt = "周六";
            break;
        case 0:
            dayTxt = "周日";
            break;
    }
    return dayTxt;
}

export function randomString(len) {
    len = len || 32;
    var $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';    /****默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1****/
    var maxPos = $chars.length;
    var pwd = '';
    for (var i = 0; i < len; i++) {
        pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
    }
    return pwd;
}

//获取图片的正确地址
export function getImageUrl(url) {
    if (url == undefined || url == null || url == "") {
        return "";
    } else if (url.indexOf("http") == 0) {
        return url;
    } else {
        if (url.substring(0, 1) == "/") return api + url;
        return api + "/" + url;
    }
}

// 将两个字典根据键来交换值
export function swapValue(target, source) {
    let params = {}
    for (const key in target) {
        if (source.hasOwnProperty(key)) {
            params[key] = source[key]
        }
        else {
            params[key] = ""
        }
    }

    return params
}

// log方法
export function log(base, number) {
    return Math.log(number) / Math.log(base);
}

// lg方法
export function lg(number) {
    return Math.log(number) / Math.log(10);
}

// 下载文件
export function downloadFile(fileUrl, fileName) {
    axios.get(getImageUrl(fileUrl), { responseType: "blob" }).then(response => {
        const blob = new Blob([response.data]);
        const a = document.createElement("a");
        // 创建下载的链接
        a.href = window.URL.createObjectURL(blob);
        a.download = fileName;
        a.style.display = "none";
        //a标签追加元素到body内
        document.body.appendChild(a);
        //模拟点击下载
        a.click();
        // 下载完成移除元素
        document.body.removeChild(a);
        // 释放掉blob对象
        window.URL.revokeObjectURL(a.href);
    }).catch(console.error);
}


// 带query的跳转
export function queryPush(app, params) {
    const { path, query } = app.$route
    let hasIn = false
    for (const key in params) {
        if (key == 'query') {
            params[key] = { ...query, ...params[key] }
            hasIn = true
        }
    }
    if (!hasIn) params['query'] = query
    app.$router.push(params);
}

// 相应字符串改为用{}占位的字符串
// 例如："2通道超过154cm/s" 通过对象 {"{}通道超过{}cm/s": "{} channel over {} cm/s"} 改为 "2 channel over 154 cm/s"
export function translateString(str) {
    let langData = store.getters.getLangData
    if (langData.lang == 'cn') return str

    let mapping = store.getters.getTipsLangData
    const keys = Object.keys(mapping);

    for (const key of keys) {
        // 将 {} 替换为捕获任意非空字符的正则
        const pattern = key.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
            .replace(/\\\{\\\}/g, '([^\\s]+)')
            .replace(/\{\}/g, '([^\\s]+)');

        const regex = new RegExp(`^${pattern}$`);
        const match = str.match(regex);

        if (match) {
            let result = mapping[key];
            // 替换所有的 {}
            for (let i = 1; i < match.length; i++) {
                result = result.replace(/\{\}/, match[i]);
            }

            return result;
        }
    }

    return str;
}


// WEBPACK FOOTER //
// ./src/utils/utils.js